import React from "react";

interface IconProps {
  size?: number;
  viewBox?: string;
  className?: string;
  color?: string;
  children: React.ReactNode;
}

export const Icon: React.FC<IconProps> = ({
  size = 16,
  viewBox = "0 0 1024 1024",
  className = "",
  color = "currentColor",
  children,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
};
